/* eslint-disable */

import React, { useState, useMemo } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

const GridRowDetailsExpand = ({
  showDialog,
  hoverPos,
  isDetailBoxOpen,
  setIsDetailBoxOpen,
  selectedRow,
  isErrGrid = false,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleCloseDetailBox = () => {
    setIsDetailBoxOpen(false);
    setSearchTerm(""); // reset search when closing
  };

  // Filtered row details based on search term
  const filteredDetails = useMemo(() => {
    if (!searchTerm) return Object.entries(selectedRow);
    return Object.entries(selectedRow).filter(
      ([field, value]) =>
        field.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (value &&
          value.toString().toLowerCase().includes(searchTerm.toLowerCase()))
    );
  }, [selectedRow, searchTerm]);

  return (
    <>
      {/* Row Details Dialog */}
      {isDetailBoxOpen && (
        <Dialog
          open={isDetailBoxOpen}
          onClose={handleCloseDetailBox}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 2,
              boxShadow: "0px 10px 30px rgba(0,0,0,0.15)",
            },
          }}
          style={{ zIndex: 999999999 }}
          disableScrollLock={true}
        >
          <DialogTitle
            sx={{
              fontWeight: 700,
              fontSize: "1.25rem",
              borderBottom: "1px solid #e0e0e0",
              pb: 1.5,
              background: isErrGrid
                ? "linear-gradient(135deg, rgb(250 105 105) 0%, rgb(255, 137, 137) 100%)"
                : "#1976d2",
              color: "white",
            }}
          >
            Row Details
          </DialogTitle>

          <DialogContent dividers sx={{ p: 3 }}>
            {/* Search Input */}
            <TextField
              fullWidth
              size="small"
              placeholder="Search fields or values..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  padding: 1,
                },
              }}
            />

            {filteredDetails.length === 0 ? (
              <Typography variant="body2" color="text.secondary">
                No matching details found.
              </Typography>
            ) : (
              filteredDetails.map(([field, value]) => (
                <Box
                  key={field}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    mb: 2,
                  }}
                >
                  {/* Left column: fixed width */}
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    sx={{
                      minWidth: "120px",
                      maxWidth: "20rem",
                      width: "100%",
                      textAlign: "start",
                      color: "black",
                      pr: 2,
                    }}
                  >
                    {field}
                  </Typography>

                  {/* Right column: flexible */}
                  <Box
                    className="grid-row-details"
                    sx={{
                      flex: 1,
                      minHeight: "40px",
                      maxHeight: "180px",
                      overflow: "auto",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      padding: "10px 12px",
                      backgroundColor: "#f5f5f5",
                      borderRadius: 2,
                      border: "1px solid #ddd",
                      fontSize: 14,
                      color: "#333",
                    }}
                  >
                    {value}
                  </Box>
                </Box>
              ))
            )}
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button
              onClick={handleCloseDetailBox}
              variant="outlined"
              sx={{
                borderColor: "#1976d2",
                color: "#1976d2",
                "&:hover": {
                  backgroundColor: "#e3f2fd",
                  borderColor: "#1976d2",
                },
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Hover Tooltip */}
      {showDialog && hoverPos && (
        <Box
          sx={{
            position: "fixed",
            top: hoverPos.y + 12,
            left: hoverPos.x + 12,
            backgroundColor: "#ffffff",
            color: "#333",
            padding: "8px 14px",
            borderRadius: 2,
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            pointerEvents: "none",
            zIndex: 9999,
            whiteSpace: "nowrap",
            userSelect: "none",
            fontSize: 13,
            fontWeight: 500,
            fontFamily: "Poppins, sans-serif",
            animation: "fadeIn 0.2s ease-in-out",
          }}
        >
          Double click on the row to expand details
        </Box>
      )}
    </>
  );
};

export default GridRowDetailsExpand;
